'use client'
import React, { FC } from 'react'
import styles from './CollectionContainedDropDownSelect.module.css'
import { ChevronLeft } from '@mui/icons-material'
import ClearIcon from '@mui/icons-material/Clear';
import classNames from 'classnames'
import { FormControl, MenuItem, Select, ThemeProvider, createTheme } from '@mui/material'
import { Collection } from '@/utils/types/collections'
import CollectionIcon from '@/components/collection-icon'
import { FILTER_COLLECTIONS_DEFAULT_ID } from '@/utils/constants'

const theme = createTheme({
	components: {
		MuiPaper: {
			styleOverrides: {
				root: {
					maxHeight: '250px !important'
				}
			}
		},
		MuiFormControl: {
			styleOverrides: {
				root: {
					display: 'flex !important'
				}
			}
		},
	}
})

const CollectionContainedDropdownSelect: FC<{
	selected: string
	options: { title: string; id: string; slug?: string; onClick?: () => void }[]
	onSelect?: (e: any) => void
	collection?: any
	setSelected?: (filter: string, slug: string) => void
}> = (props) => {
	const { selected, options, onSelect } = props
	const [open, setOpen] = React.useState(false)
	const handleSetOpen = React.useCallback(() => setOpen(true), [])
	const handleSetClosed = React.useCallback(() => setOpen(false), [])
	const handleArrowClick = React.useCallback(() => setOpen((prev) => !prev), [])

	const renderOptions = React.useCallback(
		({ title, id, slug, collection, onClick }: any, i: any) => {
			const activeItem = id === selected
			return (
					<MenuItem
						key={i}
						selected={activeItem}
						className={classNames('text-xs', {
							['text-foreground font-bold bg-transparent']: activeItem,
							['text-foreground/80 bg-transparent']: !activeItem,
							[styles.displayNone]: id == FILTER_COLLECTIONS_DEFAULT_ID
						})}
						value={id}
						onClick={typeof(props.setSelected) === 'function' ? () => (props as any).setSelected(id, slug) : onClick}
					>
							{collection ?
								<div className={classNames(styles.nameContainer)}>
									<CollectionIcon
										className={styles.icon}
										imageClassName={styles.icon}
										// @ts-ignore
										collection={collection as Collection}
									/>
									<p className={styles.textCenter}>{title}</p>
								</div>
							: 
								<div className={classNames(styles.nameContainer)}>
									<p className={styles.textCenter}>{title}</p>
									<div
										className={styles.icon}
									/>
								</div>}
					</MenuItem>
			)
		},
		[props, selected]
	)

	const handleChange = React.useCallback(
		(e: any) => {
			onSelect && onSelect(e)
		},
		[onSelect]
	)

	return (
		<div className={styles.root}>
			<ThemeProvider theme={theme}>
				<FormControl>
					<Select
						open={open}
						MenuProps={{
							classes: { paper: 'bg-card mt-2 border rounded-3xl border-border' }
						}}
						classes={{
							nativeInput: 'outline-none focus:outline-none',
							select: 'p-0 pl-6 pr-1 h-full flex items-center focus:outline-none'
						}}
						className="cursor-pointer p-0 pr-5 text-foreground text-sm font-bold h-11 border rounded-full border-border bg-card outline-none focus:outline-none"
						value={selected}
						onChange={handleChange}
						IconComponent={() => (
							<div className={styles.clearArrowWidth}>
								{selected !== FILTER_COLLECTIONS_DEFAULT_ID && typeof(props.setSelected) === 'function' ? <ClearIcon
									onClick={typeof(props.setSelected) === 'function' ? () => (props as any).setSelected(FILTER_COLLECTIONS_DEFAULT_ID, '') : handleArrowClick}
									className={classNames('h-5 w-6 fill-foreground')}
								/> : []}
								<ChevronLeft
									onClick={handleArrowClick}
									className={classNames('h-5 w-6 fill-foreground', {
										['rotate-90']: open,
										['-rotate-90']: !open
									})}
								/>
								{selected === FILTER_COLLECTIONS_DEFAULT_ID && typeof(props.setSelected) === 'function' ? <ClearIcon
									onClick={handleArrowClick}
									className={classNames('h-5 ml-3 w-6 fill-transparent')}
									style={typeof(props.setSelected) === 'function' ? {display: 'none'} : {}}
								/> : []}
							</div>
						)}
						onOpen={handleSetOpen}
						onClose={handleSetClosed}
					>
						{options.map(renderOptions)}
					</Select>
				</FormControl>
			</ThemeProvider>
		</div>
	)
}

export default CollectionContainedDropdownSelect
